import { inject, Pipe, PipeTransform } from '@angular/core';
import { CommonGeneralConfigService } from '../services/common-general-config.service';
import { parsePhoneNumber } from 'libphonenumber-js';

@Pipe({
  name: 'formatPhoneNumber'
})
export class FormatPhoneNumberPipe implements PipeTransform {

  protected generalConfigService = inject(CommonGeneralConfigService);

  transform(phoneValue: number | string, wrapCountryCodeInParentheses?: boolean): string {
    const stringPhone = this.formatPhoneValue(phoneValue);
    const phoneNumber = parsePhoneNumber(stringPhone);

    if (!phoneNumber) {
      return stringPhone;
    }

    let formatted = phoneNumber.formatInternational();
    if (this.shouldUseCountryCodeSeparator(wrapCountryCodeInParentheses)) {
      const countryCode = phoneNumber.countryCallingCode;
      formatted = formatted.replace(`+${countryCode}`, `(+${countryCode})`);
    }

    return formatted;
  }

  private formatPhoneValue(phoneValue: number | string): string {
    let stringPhone = phoneValue?.toString()?.trim();
    if (!stringPhone.startsWith('+')) {
      stringPhone = stringPhone.startsWith('00')
        ? `+${stringPhone.substring(2)}`
        : `+${stringPhone}`;
    }
    return stringPhone;
  }

  private shouldUseCountryCodeSeparator(wrapCountryCodeInParentheses?: boolean): boolean {
    return wrapCountryCodeInParentheses !== undefined
      ? wrapCountryCodeInParentheses
      : this.generalConfigService.getConfigProperty('formatPhoneNumberPipe.wrapCountryCodeInParentheses');
  }
}
